import React from 'react';
import styled from 'styled-components/macro';

export const CardGridLoading = ({ orientation }) => {
  const cardWidths = [
    80, 90, 60, 70, 80, 60, 70, 80, 80, 90, 60, 70, 80, 60, 70, 80,
  ];
  return (
    <Loading orientation={orientation}>
      {orientation !== 'horizontal' ? (
        <>
          {cardWidths.map((cardWidth, i) => (
            <LoadingCard key={i}>
              <LoadingImage />
              <LoadingText width={cardWidth} />
            </LoadingCard>
          ))}
        </>
      ) : (
        <>
          {cardWidths.map((cardWidth, i) => (
            <LoadingCardHoriz key={i}>
              <LoadingImageHoriz />
              <LoadingText width={cardWidth} />
              <LoadingText width={40} />
            </LoadingCardHoriz>
          ))}
        </>
      )}
    </Loading>
  );
};

const Loading = styled.div`
  display: grid;
  max-width: 1596px;
  padding-top: 20px;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  @media screen and (min-width: 678px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media screen and (min-width: 1440px) {
    grid-template-columns: repeat(5, 1fr);
  }
  @media screen and (min-width: 1830px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media screen and (min-width: 2078px) {
    grid-template-columns: repeat(7, 1fr);
  }
`;

const LoadingCard = styled.div`
  margin-right: 12px;
  width: 100%;
`;

const LoadingCardHoriz = styled.div`
  padding-left: 90px;
  position: relative;
  height: 90px;
`;

const LoadingImageHoriz = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 8px;
  height: 72px;
  left: 0;
  position: absolute;
  top: 0;
  width: 72px;
`;

const LoadingImage = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 8px;
  height: 0;
  padding-bottom: 56.25%;
  width: 100%;
`;

const LoadingText = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 2px;
  height: 12px;
  margin-top: 12px;
  width: ${(props) => props.width}%;
`;
